import { _ as __assign } from './_tslib-ff3a08af.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { makeStyles, TextareaAutosize } from '@material-ui/core';
import { c as createCommonjsModule, g as getDefaultExportFromCjs } from './_commonjsHelpers-471920d6.js';
import React from 'react';
import _propTypes from 'prop-types';
import { L as LoadingData } from './LoadingData-d24d8384.js';
import './globalButtonStyles-41c8af84.js';
import { s as styleConstants } from './constants-3b80be2a.js';

var AutosizeInput_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _react2 = _interopRequireDefault(React);



var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var sizerStyle = {
	position: 'absolute',
	top: 0,
	left: 0,
	visibility: 'hidden',
	height: 0,
	overflow: 'scroll',
	whiteSpace: 'pre'
};

var INPUT_PROPS_BLACKLIST = ['extraWidth', 'injectStyles', 'inputClassName', 'inputRef', 'inputStyle', 'minWidth', 'onAutosize', 'placeholderIsMinWidth'];

var cleanInputProps = function cleanInputProps(inputProps) {
	INPUT_PROPS_BLACKLIST.forEach(function (field) {
		return delete inputProps[field];
	});
	return inputProps;
};

var copyStyles = function copyStyles(styles, node) {
	node.style.fontSize = styles.fontSize;
	node.style.fontFamily = styles.fontFamily;
	node.style.fontWeight = styles.fontWeight;
	node.style.fontStyle = styles.fontStyle;
	node.style.letterSpacing = styles.letterSpacing;
	node.style.textTransform = styles.textTransform;
};

var isIE = typeof window !== 'undefined' && window.navigator ? /MSIE |Trident\/|Edge\//.test(window.navigator.userAgent) : false;

var generateId = function generateId() {
	// we only need an auto-generated ID for stylesheet injection, which is only
	// used for IE. so if the browser is not IE, this should return undefined.
	return isIE ? '_' + Math.random().toString(36).substr(2, 12) : undefined;
};

var AutosizeInput = function (_Component) {
	_inherits(AutosizeInput, _Component);

	_createClass(AutosizeInput, null, [{
		key: 'getDerivedStateFromProps',
		value: function getDerivedStateFromProps(props, state) {
			var id = props.id;

			return id !== state.prevId ? { inputId: id || generateId(), prevId: id } : null;
		}
	}]);

	function AutosizeInput(props) {
		_classCallCheck(this, AutosizeInput);

		var _this = _possibleConstructorReturn(this, (AutosizeInput.__proto__ || Object.getPrototypeOf(AutosizeInput)).call(this, props));

		_this.inputRef = function (el) {
			_this.input = el;
			if (typeof _this.props.inputRef === 'function') {
				_this.props.inputRef(el);
			}
		};

		_this.placeHolderSizerRef = function (el) {
			_this.placeHolderSizer = el;
		};

		_this.sizerRef = function (el) {
			_this.sizer = el;
		};

		_this.state = {
			inputWidth: props.minWidth,
			inputId: props.id || generateId(),
			prevId: props.id
		};
		return _this;
	}

	_createClass(AutosizeInput, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			this.mounted = true;
			this.copyInputStyles();
			this.updateInputWidth();
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate(prevProps, prevState) {
			if (prevState.inputWidth !== this.state.inputWidth) {
				if (typeof this.props.onAutosize === 'function') {
					this.props.onAutosize(this.state.inputWidth);
				}
			}
			this.updateInputWidth();
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this.mounted = false;
		}
	}, {
		key: 'copyInputStyles',
		value: function copyInputStyles() {
			if (!this.mounted || !window.getComputedStyle) {
				return;
			}
			var inputStyles = this.input && window.getComputedStyle(this.input);
			if (!inputStyles) {
				return;
			}
			copyStyles(inputStyles, this.sizer);
			if (this.placeHolderSizer) {
				copyStyles(inputStyles, this.placeHolderSizer);
			}
		}
	}, {
		key: 'updateInputWidth',
		value: function updateInputWidth() {
			if (!this.mounted || !this.sizer || typeof this.sizer.scrollWidth === 'undefined') {
				return;
			}
			var newInputWidth = void 0;
			if (this.props.placeholder && (!this.props.value || this.props.value && this.props.placeholderIsMinWidth)) {
				newInputWidth = Math.max(this.sizer.scrollWidth, this.placeHolderSizer.scrollWidth) + 2;
			} else {
				newInputWidth = this.sizer.scrollWidth + 2;
			}
			// add extraWidth to the detected width. for number types, this defaults to 16 to allow for the stepper UI
			var extraWidth = this.props.type === 'number' && this.props.extraWidth === undefined ? 16 : parseInt(this.props.extraWidth) || 0;
			newInputWidth += extraWidth;
			if (newInputWidth < this.props.minWidth) {
				newInputWidth = this.props.minWidth;
			}
			if (newInputWidth !== this.state.inputWidth) {
				this.setState({
					inputWidth: newInputWidth
				});
			}
		}
	}, {
		key: 'getInput',
		value: function getInput() {
			return this.input;
		}
	}, {
		key: 'focus',
		value: function focus() {
			this.input.focus();
		}
	}, {
		key: 'blur',
		value: function blur() {
			this.input.blur();
		}
	}, {
		key: 'select',
		value: function select() {
			this.input.select();
		}
	}, {
		key: 'renderStyles',
		value: function renderStyles() {
			// this method injects styles to hide IE's clear indicator, which messes
			// with input size detection. the stylesheet is only injected when the
			// browser is IE, and can also be disabled by the `injectStyles` prop.
			var injectStyles = this.props.injectStyles;

			return isIE && injectStyles ? _react2.default.createElement('style', { dangerouslySetInnerHTML: {
					__html: 'input#' + this.state.inputId + '::-ms-clear {display: none;}'
				} }) : null;
		}
	}, {
		key: 'render',
		value: function render() {
			var sizerValue = [this.props.defaultValue, this.props.value, ''].reduce(function (previousValue, currentValue) {
				if (previousValue !== null && previousValue !== undefined) {
					return previousValue;
				}
				return currentValue;
			});

			var wrapperStyle = _extends({}, this.props.style);
			if (!wrapperStyle.display) wrapperStyle.display = 'inline-block';

			var inputStyle = _extends({
				boxSizing: 'content-box',
				width: this.state.inputWidth + 'px'
			}, this.props.inputStyle);

			var inputProps = _objectWithoutProperties(this.props, []);

			cleanInputProps(inputProps);
			inputProps.className = this.props.inputClassName;
			inputProps.id = this.state.inputId;
			inputProps.style = inputStyle;

			return _react2.default.createElement(
				'div',
				{ className: this.props.className, style: wrapperStyle },
				this.renderStyles(),
				_react2.default.createElement('input', _extends({}, inputProps, { ref: this.inputRef })),
				_react2.default.createElement(
					'div',
					{ ref: this.sizerRef, style: sizerStyle },
					sizerValue
				),
				this.props.placeholder ? _react2.default.createElement(
					'div',
					{ ref: this.placeHolderSizerRef, style: sizerStyle },
					this.props.placeholder
				) : null
			);
		}
	}]);

	return AutosizeInput;
}(React.Component);

AutosizeInput.propTypes = {
	className: _propTypes2.default.string, // className for the outer element
	defaultValue: _propTypes2.default.any, // default field value
	extraWidth: _propTypes2.default.oneOfType([// additional width for input element
	_propTypes2.default.number, _propTypes2.default.string]),
	id: _propTypes2.default.string, // id to use for the input, can be set for consistent snapshots
	injectStyles: _propTypes2.default.bool, // inject the custom stylesheet to hide clear UI, defaults to true
	inputClassName: _propTypes2.default.string, // className for the input element
	inputRef: _propTypes2.default.func, // ref callback for the input element
	inputStyle: _propTypes2.default.object, // css styles for the input element
	minWidth: _propTypes2.default.oneOfType([// minimum width for input element
	_propTypes2.default.number, _propTypes2.default.string]),
	onAutosize: _propTypes2.default.func, // onAutosize handler: function(newWidth) {}
	onChange: _propTypes2.default.func, // onChange handler: function(event) {}
	placeholder: _propTypes2.default.string, // placeholder text
	placeholderIsMinWidth: _propTypes2.default.bool, // don't collapse size to less than the placeholder
	style: _propTypes2.default.object, // css styles for the outer element
	value: _propTypes2.default.any // field value
};
AutosizeInput.defaultProps = {
	minWidth: 1,
	injectStyles: true
};

exports.default = AutosizeInput;
});

var AutosizeInput = /*@__PURE__*/getDefaultExportFromCjs(AutosizeInput_1);

var WIDTH_FACTOR = 28;
var useStyles = makeStyles(function (theme) {
    return {
        autosize: {
            borderRadius: 4,
            color: '#333333',
            outline: 'none',
            border: function (_a) {
                var customBorderColor = _a.customBorderColor;
                return "2px solid ".concat(customBorderColor);
            },
            fontFamily: 'Ubuntu Sans',
            maxWidth: function (_a) {
                var maxWidth = _a.maxWidth;
                return maxWidth;
            },
            '& input': {
                maxWidth: function (_a) {
                    var maxWidth = _a.maxWidth;
                    return typeof maxWidth === 'number' ? maxWidth - WIDTH_FACTOR : "calc(".concat(maxWidth, " - ").concat(WIDTH_FACTOR, "px)");
                },
                padding: theme.spacing(0, 3),
                color: '#333333',
                fontWeight: 700,
                fontFamily: 'Ubuntu Sans, sans-serif',
                border: 0,
                fontSize: 14,
                height: 23,
                outline: 'none',
                textAlign: 'center'
            },
            backgroundColor: '#FFF',
            fontWeight: 600
        },
        autosizeDisabled: {
            border: "2px solid #DDDDDD",
            '& input': {
                color: 'hsl(0, 0%, 60%)'
            }
        },
        textarea: {
            minWidth: function (_a) {
                var minWidth = _a.minWidth;
                return minWidth;
            },
            maxWidth: function (_a) {
                var maxWidth = _a.maxWidth;
                return maxWidth;
            },
            padding: theme.spacing(3),
            resize: 'none',
            overflow: 'auto'
        },
        textareaDisabled: {
            color: 'hsl(0, 0%, 60%)',
            backgroundColor: '#EFEFEF4D'
        }
    };
});
var CustomInput = function (_a) {
    var name = _a.name,
        value = _a.value,
        onChange = _a.onChange,
        onEnterPress = _a.onEnterPress,
        type = _a.type,
        step = _a.step,
        _b = _a.minWidth,
        minWidth = _b === void 0 ? 60 : _b,
        _c = _a.maxWidth,
        maxWidth = _c === void 0 ? 180 : _c,
        _d = _a.disabled,
        disabled = _d === void 0 ? false : _d,
        _e = _a.error,
        error = _e === void 0 ? false : _e,
        _f = _a.loading,
        loading = _f === void 0 ? false : _f,
        _g = _a.customBorderColor,
        customBorderColor = _g === void 0 ? styleConstants.colors.primaryColor : _g,
        _h = _a.textArea,
        textArea = _h === void 0 ? false : _h,
        _j = _a.textAreaRows,
        textAreaRows = _j === void 0 ? 4 : _j,
        _k = _a.textAreaMaxHeight,
        textAreaMaxHeight = _k === void 0 ? undefined : _k,
        _l = _a.dataTestId,
        dataTestId = _l === void 0 ? undefined : _l,
        customStyles = _a.customStyles;
    var classes = useStyles({ customBorderColor: customBorderColor, minWidth: minWidth, maxWidth: maxWidth });
    return jsxs("div", { className: "relative", children: [loading && jsx(LoadingData, { overlapParent: true }), !textArea ? jsx(AutosizeInput, { className: "".concat(classes.autosize, " ").concat(disabled ? classes.autosizeDisabled : ''), value: value, onChange: function (e) {
                return onChange === null || onChange === void 0 ? void 0 : onChange(e);
            }, name: name, type: type || 'text', step: step || null, minWidth: minWidth, disabled: disabled, style: __assign(__assign({}, customStyles), error ? { borderColor: 'red' } : {}), onKeyUp: onEnterPress ? function (event) {
                if (event.key === 'Enter') onEnterPress();
            } : null, "data-testid": dataTestId }) : jsx(TextareaAutosize, { className: "".concat(classes.autosize, " ").concat(classes.textarea, " ").concat(disabled ? "".concat(classes.autosizeDisabled, " ").concat(classes.textareaDisabled) : ''), value: value !== null && value !== void 0 ? value : '', onChange: function (e) {
                return onChange === null || onChange === void 0 ? void 0 : onChange(e);
            }, name: name, rowsMin: textAreaRows, disabled: disabled, style: __assign(__assign(__assign({}, customStyles), textAreaMaxHeight ? { maxHeight: textAreaMaxHeight } : {}), error ? { borderColor: 'red' } : {}), onKeyUp: onEnterPress ? function (event) {
                if (event.key === 'Enter') onEnterPress();
            } : null, "data-testid": dataTestId })] });
};

export { AutosizeInput as A, CustomInput as C };
